// attachinary.coffee
import "./coufigure";
import "./gallery";
import "./refile";
import "./slider";
import "./slideshow";
import "./turbolinks";
